// 新規物件作成モーダル
const ModalNewPropertyLinkList = {
  namespaced: true,

  state: {
    modal: false,
    tab: 'residence', // residence, investment
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getTab: state => {
      return state.tab
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setTab(state, tab) {
      state.tab = tab
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setTab', item.tab)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setTab', 'residence')
    },
  },
}

export default ModalNewPropertyLinkList
